angular
  .module('components')

  .directive('tableInputFilesEditable', function() {
    return {
      restrict: 'E',
      scope: {
        path: '<',
        filesNumber: '=',
        hideSector: '<',
        isContributor: '<',
        firstFileDestination: '=',
        saveProject: '&'
      },
      templateUrl:
        'custom/components/views/partials/tableInputFilesEditable.html',
      controller: [
        '$scope',
        '$element',
        '$controller',
        '$timeout',
        'UserLang',
        function($scope, $element, $controller, $timeout, UserLang) {
          $scope.enableListLoading = true;
          $scope.editable = true;
          $scope.userLang = UserLang.get();

          $controller('filesController', {
            $scope: $scope,
            $element: $element
          });

          $scope.setFileDestination = destination => {
            $scope.updateFilesData('destination', destination);
            $scope.firstFileDestination = destination;
            $timeout(() => $scope.saveProject());
          };

          $scope.$watch('files', function(newValue) {
            if (!($scope.filesNumber === undefined) && newValue) {
              $scope.filesNumber = newValue.length;
            }
          });
        }
      ]
    };
  });
